import purushoth from "../images/Organizers/purushoth.webp";
import murshid from "../images/Organizers/Murshid.png";
import aden from "../images/Organizers/aden2.png";
import aadav from "../images/Organizers/aadav.png";
import karan from "../images/Organizers/karan.png";
import madavan from "../images/Organizers/madhavan.png";
import kanag from "../images/Organizers/kanag.png";
import teju from "../images/Organizers/teju.png";
import swa from "../images/Organizers/swa.png";
import nav from "../images/Organizers/nav.png";
import sai from "../images/Organizers/sai.png";
import hay from "../images/Organizers/hay.png";
import sakthi from "../images/Organizers/sakthi.png";
export const organizers = [
  {
    id: 1,
    name: "Purushothaman",
    role: "Course • Mindful Mike",
    imgSrc: purushoth,
  },
  {
    id: 2,
    name: "Aden Joe",
    role: "Wellness Coach",
    imgSrc: aden,
  },
  {
    id: 3,
    name: "Sakthilakshmi",
    role: "Fitness Trainer",
    imgSrc: sakthi,
  },
  {
    id: 4,
    name: "Murshid",
    role: "Fitness Trainer",
    imgSrc: murshid,
  },

  {
    id: 5,
    name: "Karan Balaji",
    role: "Fitness Trainer",
    imgSrc: karan,
  },
  {
    id: 6,
    name: "Tejashree",
    role: "Fitness Trainer",
    imgSrc: teju,
  },
  {
    id: 7,
    name: "Kanaga Shanmugam",
    role: "Fitness Trainer",
    imgSrc: kanag,
  },
  {
    id: 7,
    name: "Naveen Kumar",
    role: "Fitness Trainer",
    imgSrc: nav,
  },
  {
    id: 7,
    name: "Sai Prasad",
    role: "Fitness Trainer",
    imgSrc: sai,
  },
  {
    id: 7,
    name: "Aadav",
    role: "Fitness Trainer",
    imgSrc: aadav,
  },
  {
    id: 7,
    name: "Madhavan",
    role: "Fitness Trainer",
    imgSrc: madavan,
  },
  {
    id: 7,
    name: "Swathi",
    role: "Fitness Trainer",
    imgSrc: swa,
  },
  {
    id: 7,
    name: "Hayagreevan",
    role: "Fitness Trainer",
    imgSrc: hay,
  },
];
